import { RESOURCE_TILES } from "../../content/resources";
import { langFromPath } from "../../i18n/lang";
import { Page } from "../../layout/Page";
import { Reveal } from "../../ui/Reveal";
import { Section } from "../../ui/Section";
import { Tile } from "../../ui/Tile";

/**
 * The old site's `/resources` (and `/resources-HI`): six tiles to the
 * audio/video, slide reading, scientific research, newsletter/magazine and
 * prayer & music sub-pages, plus Divine Quotes linking out to Instagram.
 */
export function ResourcesPage() {
  const { lang } = langFromPath(window.location.pathname);

  return (
    <Page title="Resources" heading="Resources">
      <Section>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {RESOURCE_TILES.map((tile) => (
            <Reveal key={tile.href}>
              <Tile
                tone={tile.tone}
                title={tile.title[lang]}
                sub={tile.sub[lang]}
                href={tile.href}
                external={tile.external}
              />
            </Reveal>
          ))}
        </div>
      </Section>
    </Page>
  );
}
